import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FormattedMessage } from 'ui/i18n';

import './EmptyCartModal.scss';

export default class EmptyCartModal extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
	};

	render() {
		const { show, onRequestClose } = this.props;
		return (
			<Modal
				className="ReactModal__Content EmptyCartModal"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={onRequestClose}
				contentLabel="Empty Cart"
			>
				<div className="EmptyCartModal-warning-msg">
					<h4>
						<strong>
							<FormattedMessage id="general.pleaseFillInTitle" />
						</strong>
					</h4>
					<hr />
					<h5 id="EmptyCartValidationMessage">
						<FormattedMessage id="general.pleaseFillInMessage" />
					</h5>
					<button
						className="btn btn-primary pull-right"
						onClick={onRequestClose}
					>
						OK
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/EmptyCartModal/index.js